import type { AnalyticsArgs } from './types'
import mixpanel from 'mixpanel-browser'
import { useAccountStore } from '~/stores/account'

export function analytics(...[event, payload = {}]: AnalyticsArgs) {
  try {
    const route = useRoute()
    const accountStore = useAccountStore()

    const rules = [
      'WebView',
      '(iPhone|iPod|iPad)(?!.*Safari)',
      'Android.*Version/[0-9].[0-9]',
      'Android.*wv',
      'Linux; U; Android'
    ]

    const isWebview = () => {
      const userAgent: string | undefined =
        navigator.userAgent || (window as any).opera

      if (userAgent) {
        const regex = new RegExp(`(${rules.join('|')})`, 'ig')

        return !!userAgent.match(regex)
      }

      return false
    }

    const isMobileDevice = () =>
      /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      )

    const buildScreenName = route.name === 'index' ? 'home' : route.name

    if (accountStore?.account?.id) {
      mixpanel.identify(accountStore.account.id)
    }

    let currentLayout = null

    if (isWebview()) {
      currentLayout = 'app'
    } else if (isMobileDevice()) {
      currentLayout = 'mobile'
    } else {
      currentLayout = 'desktop'
    }

    mixpanel.track(event, {
      ...payload,
      screen_name: payload.screen_name ?? buildScreenName,
      current_layout: currentLayout
    })
  } catch {}
}
